import {
  GameAttributionPlatform,
  GamePlatformType,
  GameTaskType,
} from "../store/types"

export const gamePlatformOptions = [
  { value: GamePlatformType.ANDROID, label: "Android" },
  { value: GamePlatformType.IOS, label: "iOS" },
]

export const attributionPlatformOptions = [
  { value: GameAttributionPlatform.ADJUST, label: GameAttributionPlatform.ADJUST },
  { value: GameAttributionPlatform.APPS_FLYER, label: GameAttributionPlatform.APPS_FLYER },
  { value: GameAttributionPlatform.SINGULAR, label: GameAttributionPlatform.SINGULAR },
  { value: GameAttributionPlatform.EVERFLOW, label: GameAttributionPlatform.EVERFLOW },
]

export const gameTaskTypeOptions = [
  { value: GameTaskType.LEVEL_TASK, label: GameTaskType.LEVEL_TASK },
  { value: GameTaskType.BONUS_TASK, label: GameTaskType.BONUS_TASK },
  { value: GameTaskType.CASHBACK_TASK, label: GameTaskType.CASHBACK_TASK },
  { value: GameTaskType.INSTALL_TASK, label: GameTaskType.INSTALL_TASK },
  { value: GameTaskType.WATCH_AN_ADS_TASK, label: GameTaskType.WATCH_AN_ADS_TASK },
]
